export default "__VITE_ASSET__CYI8PPxT__"